import * as Sentry from '@sentry/browser'
import * as SentryVue from '@sentry/vue'
import { App } from 'vue'
import { Router } from 'vue-router'

const dsn = import.meta.env.VITE_SENTRY_DSN

const defaultConfiguration = {
    dsn,
    environment: window.SentryConfiguration.environment,
    tracesSampleRate: window.SentryConfiguration.tracesSampleRate,
}

export function initSentryForEnrollment(app: App, router: Router) {
    if (!dsn) {
        return
    }

    SentryVue.setTag('app', 'enrollment')
    SentryVue.init({
        ...defaultConfiguration,
        app,
        integrations: [
            SentryVue.browserTracingIntegration({
                router,
            }),
        ],
    })
}

export function initSentryForStatusDashboard() {
    if (!dsn) {
        return
    }

    Sentry.setTag('app', 'status-dashboard')
    Sentry.init({
        ...defaultConfiguration,
        integrations: [Sentry.browserTracingIntegration()],
    })
}
